import styled from 'styled-components';
import { withModifiers } from 'utils/styles';

export const RiskMenuContainer = styled.div`
  display: flex;
  opacity: 0;
  transition: opacity 0.3s ease-in;

  ${withModifiers('isVisible')`
    opacity: 1;
  `}
`;
